import React, { Component } from "react";
import ReactDOM from "react-dom";

import { connect } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import { history } from "./helpers";
import Auth from "./helpers/auth";
import { configureStore } from "./store/configureStore";

import LogIn from "./screens/LogIn";
import Home from "./screens/Home";
import Projects from "./screens/Projects";
import CreateProject from "./screens/CreateProject";
import Counsellors from "./screens/Counsellors";
import CreateCounsellor from "./screens/CreateCounsellor";
import CreateAppointment from "./screens/CreateAppointment";
import CorporateReports from "./screens/CorporateReports";
import CounsellorReports from "./screens/CounsellorReports";
import NotFound from "./components/Not Found";
import unregister from "./registerServiceWorker";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { enable_Bugsnag, bugsnag_APIKEY } from "./config";

process.env.NODE_CONFIG_DIR = "../config";

Bugsnag.start({
  apiKey: bugsnag_APIKEY,
  plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
const ErrorView = () =>
  <div>
    <p>Inform users of an error in the component tree.</p>
  </div>
  
class MainApp extends Component {
  componentDidMount() {}

  render() {
    return (
      <Router history={history}>
        <div>
          <Switch>
            <Route exact path="/home" component={Auth(Home)} />
            <Route exact path="/projects" component={Auth(Projects)} />
            <Route
              exact
              path={["/create-project", "/update-project"]}
              component={Auth(CreateProject)}
            />
            <Route exact path="/counsellors" component={Auth(Counsellors)} />
            <Route
              exact
              path={["/create-counsellor", "/update-counsellor"]}
              component={Auth(CreateCounsellor)}
            />
            <Route
              exact
              path="/corporate-reports"
              component={Auth(CorporateReports)}
            />
            <Route
              exact
              path="/counsellor-reports"
              component={Auth(CounsellorReports)}
            />
            <Route
              exact
              path="/create-appointment"
              component={Auth(CreateAppointment)}
            />
            <Route path="/" component={LogIn} />
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

const App = connect(mapStateToProps)(MainApp);

ReactDOM.render(
  <ErrorBoundary FallbackComponent={ErrorView}>
    <Provider store={configureStore}>
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);
// }
unregister();



// WEBPACK FOOTER //
// ./src/index.js